import { FunctionComponent, ReactNode } from 'react'

import styled from '@emotion/styled'

import { Text } from '@cash-design-system/react'

interface Props {
  title: ReactNode
  description: ReactNode
  supportText?: ReactNode
}

const RadioLabel = styled.div`
  text-align: left;
`

export const PaymentPlanLabel: FunctionComponent<Props> = ({ title, description, supportText }) => {
  return (
    <RadioLabel>
      <div>{title}</div>
      <Text typography="labelMedium">{description}</Text>
      {supportText && (
        <Text typography="body" color="textSubtle" as="div">
          {supportText}
        </Text>
      )}
    </RadioLabel>
  )
}
